const themes = [
  {label: 'Purple', value: 1, name: 'purple'},
  {label: 'Navy', value: 2, name: 'navy'},
  {label: 'Light Blue', value: 3, name: 'lightblue'},
  {label: 'Pink', value: 4, name: 'pink'},
  {label: 'Mango Mojito', value: 5, name: 'mango-mojito'},
  {label: 'Yellow', value: 6, name: 'yellow'},
  {label: 'Dark', value: 7, name: 'dark'},
  {label: 'Tanager', value: 8, name: 'tanager'},
  {label: 'Dark Green', value: 9, name: 'darkgreen'}
];
export default themes;